import {Injectable} from '@angular/core';
import {CustomerModel} from 'src/app/models/customer-model';
import {ConfigService} from '../config/config.service';
import {EventsService} from '../event/event.service';
import {UserSessionService} from '../user-session/user-session.service';
import type {PlatformResponse} from 'src/app/interfaces/webservices-interface';
import type {Campaign} from 'src/app/interfaces/campaign-interface';
import {LobbyApiService} from '../lobby/lobby-api.service';

@Injectable()
export class BannerService {
  public customer: CustomerModel;
  private banners;

  constructor(
    private config: ConfigService,
    private userSession: UserSessionService,
    private events: EventsService,
    private lobbyApiService: LobbyApiService
  ) {
    this.banners = new Map();
    this.userSession.getCustomer().subscribe(customer => {
      this.customer = customer;
      //setTimeout(()=> this.fetchAllBanners(), 15000);
    });
    this.events.subscribe('event:authentication:logout', () => {
      const productVerticals = this.config.getConfig().PRODUCTVERTICALS;
      productVerticals.forEach(product => {
        const lobbyName = product.lobby_name;
        this.banners.delete(lobbyName);
      });
    });
  }

  async getBanners(lobbyName) {
    if (this.banners.has(lobbyName)) {
      return new Promise((resolve, reject) => {
        const data = this.banners.get(lobbyName);
        resolve(data);
      });
    } else {
      return new Promise((resolve, reject) => {
        if (this.customer?.customerId && this.userSession?.sessionToken) {
          this.lobbyApiService
            .fetchLobbiesBanners(lobbyName, true)
            .subscribe(res => {
              this.banners.set(lobbyName, res);
              resolve(res);
            });
        } else {
          // logged out state
          this.lobbyApiService
            .fetchLobbiesBanners(this.config.getConfig().LOBBY_NAME, false)
            .subscribe(res => {
              this.banners.set('_logoutState', res);
              resolve(res);
            });
        }
      });
    }
  }

  // fetch all product verticals banners
  fetchAllBanners() {
    const productVerticals = this.config.getConfig().PRODUCTVERTICALS;
    if (this.customer?.customerId && this.userSession?.sessionToken) {
      productVerticals.forEach((product, index) => {
        const lobbyName = product.lobby_name;
        this.lobbyApiService
          .fetchLobbiesBanners(lobbyName, true)
          .subscribe((res: PlatformResponse<Array<Campaign>>) => {
            this.banners.set(lobbyName, res);
            if (index === productVerticals.length - 1) {
              setTimeout(() => {
                this.events.publish('event:update:banners');
              }, 500);
            }
          });
      });
    } else {
      this.lobbyApiService
        .fetchLobbiesBanners(this.config.getConfig().LOBBY_NAME, false)
        .subscribe(res => {
          this.banners.set('_logoutState', res);
          this.events.publish('event:update:banners');
        });
    }
  }
}
